export default (function (a, f) {
  return f(a);
});